import React, { useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { NavbarItems } from './NavbarItems';
import Sidebar from './Sidebar';
import {
    MobileIcon,
    Nav, NavContainer,
    NavItem,
    NavLink,
    NavLogo,
    NavMenu
} from './StyledNavbar';

const max_width = '992px';

const NavBar = () => {
    const [mobileMenu, setMobileMenu] = useState(false);

    const handleMenuToggle = () => {
        setMobileMenu(!mobileMenu);
        // setMobileMenu(!mobileMenu);
    };

    const closeMobileMenu = () => {
        setMobileMenu(false);
    };

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth > max_width) {
                setMobileMenu(false)
            }
        }
        window.addEventListener('resize', handleResize)
    }, [])

    return (
        <Fade top duration={1000} delay={600} distance="15px">
            <Nav>
                <NavContainer>
                    <NavLogo to="/" onClick={closeMobileMenu}>
                        ANNOVIEW
                    </NavLogo>
                    <MobileIcon onClick={handleMenuToggle}>
                        {mobileMenu ? <i className="fas fa-times"></i> : <i className="fas fa-bars"></i>}
                    </MobileIcon>
                    <NavMenu activeMobile={mobileMenu}>
                        {NavbarItems.map((item, index) => {
                            return (
                                <NavItem key={index} onClick={closeMobileMenu} activeMobile={mobileMenu}>
                                    <NavLink smooth to={item.url}>{item.title}</NavLink>
                                </NavItem>
                            )
                        })}
                    </NavMenu>
                    {/*<Sidebar NavItems={NavbarItems} MobileMenu={mobileMenu} CloseClick={closeMobileMenu} />*/}
                </NavContainer>
            </Nav>
        </Fade>
    )
}

export default NavBar